import { sample } from 'effector';
import $$api from 'models/api';
import $$giftTrust from 'models/gift-trusts';

import createPollingFx from 'utils/factories/create-polling-fx';

const pollingFx = createPollingFx({
    limit: 30,
    interval: 1000,
    fx: $$api.qInstances.getJobStatusFx,
    condition: (result) => {
        return !!result.find((doc) => ['In_Progress', 'Generated', 'Deleted'].includes(doc.document_status_code));
    },
});

// When letter generation job request starts, we add it to the list of jobs
sample({
    source: $$giftTrust.$jobs,
    clock: $$giftTrust.generateGiftItemFx,
    fn: (jobs, newJob) => [...jobs, newJob],
    target: $$giftTrust.$jobs,
});

// When letter generation job request fails, we remove it from the list of jobs
sample({
    source: $$giftTrust.$jobs,
    clock: $$giftTrust.generateGiftItemFx.fail,
    fn: (jobs, filedAttempt) =>
        jobs.filter(
            (job) =>
                job.qInstanceId !== filedAttempt.params.qInstanceId &&
                job.giftTrustItemId !== filedAttempt.params.giftTrustItemId,
        ),
    target: $$giftTrust.$jobs,
});

// When letter generation job request is done, we add the job id
sample({
    source: $$giftTrust.$jobs,
    clock: $$giftTrust.generateGiftItemFx.done,
    fn: (jobs, doneAttempt) =>
        jobs.map((job) =>
            job.qInstanceId === doneAttempt.params.qInstanceId &&
            job.giftTrustItemId === doneAttempt.params.giftTrustItemId
                ? { ...job, job_id: doneAttempt.result.job_id }
                : job,
        ),
    target: $$giftTrust.$jobs,
});

// When letter generation job request is done, we start polling
sample({
    clock: $$giftTrust.generateGiftItemFx.done.map(({ params, result }) => ({
        id: params.qInstanceId,
        job: result.job_id,
    })),
    target: pollingFx,
});

// When polling is done, we remove the job from the list of jobs
sample({
    source: $$giftTrust.$jobs,
    clock: pollingFx.done,
    fn: (jobs, doneAttempt) => jobs.filter((job) => job.job_id !== doneAttempt.params.job),
    target: $$giftTrust.$jobs,
});

// When polling is done, request answers for the instance
sample({
    clock: pollingFx.done,
    fn: (result) => result.params.id,
    target: $$giftTrust.getAnswersForOneInstanceFx,
});
